import { boolean, number, object, ref, string } from 'yup';

const authSchema = object().shape({
  id: number().required(),
  name: string().nullable(),
  lastName: string().nullable(),
  token: string().required(),
  expiresIn: number().required(),
});

const loginAuthBodySchema = object().shape({
  login: string().email().required(),
  password: string().required(),
});

const phoneAuthBodySchemas = object().shape({
  phone: string().required(),
  flash: boolean().required(),
});

const checkPhoneCodeBodySchemas = object().shape({
  code: string().required(),
  phone: string().required(),
});

const forgotPasswordBodySchemas = object().shape({
  email: string().email().required(),
});

const changePasswordBodySchemas = object().shape({
  password: string().required().min(8),
  confirmPassword: string()
    .required()
    .oneOf([ref('password')]),
  login: string().required(),
  checkWord: string().required(),
});

export const AuthAPI = {
  loginAuth: StrictFetch.prepare({
    url: 'auth/login-password',
    method: HTTPMethod.POST,
    schemas: { response: authSchema, body: loginAuthBodySchema },
    options: { groupKey: 'auth' },
  }),
  forgotPassword: StrictFetch.prepare({
    url: 'auth/forgot-password',
    method: HTTPMethod.POST,
    schemas: { body: forgotPasswordBodySchemas },
    options: { groupKey: 'auth' },
  }),
  changePassword: StrictFetch.prepare({
    url: 'auth/change-password',
    method: HTTPMethod.POST,
    schemas: { body: changePasswordBodySchemas },
    options: { groupKey: 'auth' },
  }),
  phoneAuth: StrictFetch.prepare({
    url: 'auth/code',
    method: HTTPMethod.POST,
    schemas: { body: phoneAuthBodySchemas },
    options: { groupKey: 'auth' },
  }),
  checkPhoneCode: StrictFetch.prepare({
    url: 'auth/code',
    method: HTTPMethod.PUT,
    schemas: { response: authSchema, body: checkPhoneCodeBodySchemas },
    options: { groupKey: 'auth' },
  }),
  logout: StrictFetch.prepare({
    url: 'auth/logout',
    method: HTTPMethod.POST,
    options: { groupKey: 'auth' },
  }),
};
